import { useState } from 'react'

export function useIosSetting<S>(
  key: string
): [S | undefined, (value: S) => void] {
  const [value, setValue] = useState<S | undefined>(undefined)

  return [value, setValue]
}
